import { frontendURL } from 'dashboard/helper/URLHelper';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/projects'),
    name: 'wasapi_projects',
    component: () => import('./pages/ProjectsPage.vue'),
    meta: { permissions: ['administrator', 'agent'] },
  },
];
